module.exports = new __parcel__URL__("progress-simple.0e71880b.svg").toString();